<script lang="ts" setup>
defineProps<{
  image: string
}>()
</script>

<template>
  <div class="flex justify-center  flex-col h-full mx-3.5 lg:(flex-row mx-auto h-57.25)">
    <img
      v-if="image"
      class=" object-cover rounded-t-lg  w-full h-50 lg:(max-w-101.5 min-w-101.5 rounded-l-lg rounded-r-0 h-auto)"
      :src="image"
      alt=""
    >
    <div v-else class="bg-black rounded-t-lg  w-full h-50 lg:(max-w-101.5 min-w-101.5 rounded-l-lg rounded-r-0 h-auto)" />
    <div class="bg-[#343434]  text-white p-5 rounded-b-lg  lg:(pl-5 pb-5 pt-6 pr-14.5 rounded-l-0 rounded-r-lg)">
      <div class="flex items-center">
        <img alt="" src="https://belong.net/images/external/other/icon-date.svg">
        <div class="text-[#C4C4C4] ml-1.5">
          <slot name="dateTime" />
        </div>
      </div>
      <div class="my-2 font-medium text-lg tracking-wide w-full line-clamp-2">
        <slot name="title" />
      </div>
      <div
        style=" display: -webkit-box;
      -webkit-box-orient: vertical;" class="font-light text-base text-[#D3D3D3] tracking-normal  text-justify  leading-normal line-clamp-4"
      >
        <slot name="description" />
      </div>
    </div>
  </div>
</template>
